import type { WidgetConfig } from './dashboard.types';
import { WIDGET_TYPES } from './widget-types';

export const DASHBOARD_WIDGETS: WidgetConfig[] = [
  {
    id: 'files-covered',
    type: WIDGET_TYPES.FilesCovered,
    title: 'Files Covered',
    icon: 'file',
    variant: 'metric',
    metric: { label: 'Files covered' },
    position: { row: 1, column: 1, colSpan: 4 },
    // No global filter: the coverage inventory has no event time, so the API
    // ignores timeFrame and the card must not react to it either.
    filters: { global: [] },
    dataSource: { endpoint: 'files-covered' },
  },
  {
    id: 'human-identities',
    type: WIDGET_TYPES.HumanIdentities,
    title: 'Human Identities Access To Data',
    icon: 'user',
    variant: 'metric',
    metric: { label: 'Human Identities' },
    position: { row: 1, column: 5, colSpan: 4 },
    filters: { global: ['timeFrame'] },
    dataSource: { endpoint: 'human-identities' },
  },
  {
    id: 'non-human-identities',
    type: WIDGET_TYPES.NonHumanIdentities,
    title: 'Non-Human Identities Access To Data',
    icon: 'bot',
    variant: 'metric',
    metric: { label: 'Non Human Identities' },
    position: { row: 1, column: 9, colSpan: 4 },
    filters: { global: ['timeFrame'] },
    dataSource: { endpoint: 'non-human-identities' },
  },
  {
    id: 'access-discovery',
    type: WIDGET_TYPES.AccessDiscovery,
    title: 'Access Discovery',
    position: { row: 2, column: 1, colSpan: 12 },
    filters: { global: ['timeFrame'], widget: ['service'] },
    dataSource: { endpoint: 'access-discovery' },
  },
  {
    id: 'top-data-accessed',
    type: WIDGET_TYPES.TopDataAccessed,
    title: 'Top Data Accessed',
    position: { row: 3, column: 1, colSpan: 12 },
    filters: { global: ['timeFrame'], widget: ['service'] },
    dataSource: { endpoint: 'top-data-accessed' },
  },
  {
    id: 'top-identities',
    type: WIDGET_TYPES.TopIdentities,
    title: 'Top Identities by File Access',
    position: { row: 4, column: 1, colSpan: 12 },
    filters: { global: ['timeFrame'], widget: ['service'] },
    dataSource: { endpoint: 'top-identities' },
  },
  {
    id: 'sensitivity',
    type: WIDGET_TYPES.Sensitivity,
    title: 'Data Access by Sensitivity',
    position: { row: 5, column: 1, colSpan: 6 },
    filters: { global: ['timeFrame'], widget: ['service'] },
    dataSource: { endpoint: 'sensitivity' },
  },
  {
    // The stale half renders when the API publishes a top-level `stale` object,
    // and the card is duplicate-only until the warehouse builds that rollup.
    id: 'stale-duplicate-data',
    type: WIDGET_TYPES.StaleDuplicateData,
    title: 'Stale & Duplicate Data',
    position: { row: 5, column: 7, colSpan: 6 },
    filters: { global: ['timeFrame'], widget: ['service'] },
    dataSource: { endpoint: 'stale-duplicate-data' },
  },
];
